import { render, staticRenderFns } from "./appOrder.vue?vue&type=template&id=7836afde&scoped=true&"
import script from "./appOrder.vue?vue&type=script&lang=js&"
export * from "./appOrder.vue?vue&type=script&lang=js&"
import style0 from "./appOrder.vue?vue&type=style&index=0&id=7836afde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7836afde",
  null
  
)

export default component.exports